module.exports = __webpack_public_path__ + "static/media/finpassport.c489c5cc.png";